import state from './informacastlog.state'
import mutations from './informacastlog.mutations'
import actions from './informacastlog.actions'

export default {
  state,
  mutations,
  actions
}
